<template>
  <div class="home-base">
    
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getbuyerview} from '../../../api/common'
export default {
  name: 'BuyerView',
  data () {
    return {
      dates:"",
      enddates:"",
      home_url:"",
    }
  },
  computed: {
		...mapState({
    	user: state => state.member.info,
    })
  },
  created: function () {
    this.dates=Date.parse(new Date());
    this.home_url = window.location.href;
  },
  //跳转离开页面时
  destroyed() {
      if(this.user){
    		this.buyerview();
    	}
  },
  mounted () {
  	//刷新页面时
    window.addEventListener('beforeunload', (event) => {
      if(this.user){
    		this.buyerview();
    	}
    });
  },
  methods: {
  	 //发送统计
  	buyerview:function(){
    	this.enddates=Date.parse(new Date());
		  this.enddates=(this.enddates-this.dates)/1000;
		  if(this.enddates<1){
		  	this.enddates=1;
		  }else if(this.enddates>3600){
		  	this.enddates=3600;
		  }
    	getbuyerview(this.user.member_id,this.home_url,this.enddates,"2").then((res)=> {
    		
    	})
    }
  },
}
</script>
